import { useDeepBoxCoreStore } from '@/stores/deepbox/core'
import { useDeepBoxDeepBoxesBoxesNodesStore } from '@/stores/deepbox/deepboxes/boxes/nodes.ts'
import type { Box, BoxEntry, BoxInfo } from '@deepcloud/api-deep-box'

export function useBoxHelper() {
  const deepBoxCoreStore = useDeepBoxCoreStore()
  const deepBoxDeepBoxesBoxesNodesStore = useDeepBoxDeepBoxesBoxesNodesStore()

  function selectBox(box: BoxEntry) {
    if (box.boxNodeId !== deepBoxCoreStore.selectedBox?.boxNodeId) {
      deepBoxDeepBoxesBoxesNodesStore.$reset()
      if (box) {
        deepBoxCoreStore.selectedBox = box as unknown as Box
      }
    }
  }

  function isSharedBox(
    box: BoxInfo | BoxEntry,
    sharedBoxes: BoxInfo[] | BoxEntry[],
    currentOrgId: string,
  ) {
    return !!sharedBoxes.find(
      (shared) =>
        shared.boxNodeId === box.boxNodeId &&
        shared.company.companyId !== currentOrgId,
    )
  }

  return {
    selectBox,
    isSharedBox,
  }
}
